'use client';

import { c as _c } from "react/compiler-runtime";
import { useReportWebVitals } from 'next/web-vitals';
import { trackWebVitals } from '@sbt-web/tracking';
import { getOrCreatePulse } from '@/tools/tracking/utils';
export default function WebVitals(t0) {
  const $ = _c(3);
  const {
    gtmDisabled,
    advDisabled
  } = t0;
  let t1;
  if ($[0] !== advDisabled || $[1] !== gtmDisabled) {
    t1 = metric => {
      const pulseInstance = getOrCreatePulse();
      if (pulseInstance !== undefined) {
        let postfix = "";
        if (gtmDisabled) {
          postfix = "-no-gtm";
        } else {
          if (advDisabled) {
            postfix = "-no-adv";
          }
        }
        trackWebVitals(pulseInstance, metric, postfix);
      }
    };
    $[0] = advDisabled;
    $[1] = gtmDisabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useReportWebVitals(t1);
}